import React from 'react';

const Logo = ({ variant = 'full', className = '', showTagline = false, size = 'md' }) => {
  const sizes = {
    sm: { height: '32px', fontSize: '14px' },
    md: { height: '48px', fontSize: '18px' },
    lg: { height: '64px', fontSize: '24px' },
    xl: { height: '80px', fontSize: '32px' }
  };

  const currentSize = sizes[size] || sizes.md;

  if (variant === 'icon') {
    // Just the map pin for small spaces
    return (
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 48 48" 
        fill="none"
        className={className}
        style={{ height: currentSize.height, width: 'auto' }}
      >
        <path 
          d="M 24 2 C 14.6 2 7 9.6 7 19 C 7 32 24 46 24 46 C 24 46 41 32 41 19 C 41 9.6 33.4 2 24 2 Z" 
          fill="#FFD700" 
          stroke="#FF8C42" 
          strokeWidth="3"
        />
        <circle cx="24" cy="19" r="6" fill="#8B4513"/>
        <path 
          d="M 15 12 L 20 18 L 24 12 L 28 18 L 33 12" 
          stroke="#1E88E5" 
          strokeWidth="2" 
          fill="none" 
          opacity="0.5"
        />
      </svg>
    );
  }

  if (variant === 'text') {
    // Just text without icon
    return (
      <div className={`inline-flex items-baseline gap-1 ${className}`}>
        <span 
          className="font-bold" 
          style={{ 
            fontSize: currentSize.fontSize,
            background: 'linear-gradient(90deg, #FF8C42 0%, #8B4513 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}
        >
          Go
        </span>
        <span 
          className="font-bold text-[#1E88E5]" 
          style={{ fontSize: currentSize.fontSize }}
        >
          himalayan
        </span>
        <span 
          className="text-[#4A4A4A]" 
          style={{ fontSize: `calc(${currentSize.fontSize} * 0.6)` }}
        >
          .com
        </span>
      </div>
    );
  }

  // Full logo with icon
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <div className="inline-flex items-baseline gap-1">
        <span 
          className="font-bold" 
          style={{ 
            fontSize: currentSize.fontSize,
            background: 'linear-gradient(90deg, #FF8C42 0%, #8B4513 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontFamily: 'Playfair Display, serif'
          }}
        >
          Go
        </span>
        <span 
          className="font-bold text-[#1E88E5]" 
          style={{ 
            fontSize: currentSize.fontSize,
            fontFamily: 'Playfair Display, serif'
          }}
        >
          himalayan
        </span>
      </div>
      
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 30 45" 
        fill="none"
        style={{ height: currentSize.height, width: 'auto', marginLeft: '4px' }}
      >
        <path 
          d="M 15 0 C 6.7 0 0 6.7 0 15 C 0 26.3 15 45 15 45 C 15 45 30 26.3 30 15 C 30 6.7 23.3 0 15 0 Z" 
          fill="#FFD700" 
          stroke="#FF8C42" 
          strokeWidth="2"
        />
        <circle cx="15" cy="15" r="5" fill="#8B4513"/>
      </svg>
      
      {showTagline && (
        <div className="ml-4 flex items-center gap-2">
          <div className="h-[1px] w-8 bg-[#4A4A4A]" />
          <span 
            className="text-[#4A4A4A] tracking-wider uppercase" 
            style={{ fontSize: `calc(${currentSize.fontSize} * 0.35)` }}
          >
            A Road Less Traveled
          </span>
          <div className="h-[1px] w-8 bg-[#4A4A4A]" />
        </div>
      )}
    </div>
  );
};

export default Logo;
